@for (course of courses; track course) {
  <div class="card mb-3">
    <div class="card-header d-flex justify-content-between">
      {{course.DisplayNameStudents}} ({{course.CourseType}})
      <span>{{course.AcademicArea}}</span>
    </div>
    <div class="card-body">
        @if (pagename == 'favorites') {
        @if (utility.filterLookups$ | async; as lookups) {
        @if (+course.AcademicYear.split(' /')[0] < lookups.defaults.academicyear) {
        <div class="alert alert-warning p-2 mb-1">
            <i class="fa-solid fa-circle-exclamation text-warning"></i> This course was saved for a previous academic year ({{course.AcademicYear}}).
        </div>
        }
        @if (+course.AcademicYear.split(' /')[0] == lookups.defaults.academicyear) {
        <div class="alert alert-info p-2 mb-1">
            <i class="fa-solid fa-clock text-info"></i> This course was saved for the current academic year ({{course.AcademicYear}}).
        </div>
        }
        @if (+course.AcademicYear.split(' /')[0] > lookups.defaults.academicyear) {
        <div class="alert alert-success p-2 mb-1">
            <i class="fa-solid fa-forward text-success"></i> This course was saved for a future academic year ({{course.AcademicYear}}).
        </div>
        }
        }
        }
        @if (column =='all' || column!='desc') {
        <section-list [sections]="course.Sections" [instructors]="people" [compareColumn]="column" [pagename]="pagename"></section-list>
        }
        @if ((column =='all' || column =='desc') && course.Description.length>0) {
        <h5>Course Description</h5>
        @if (column == 'all') {
        <p [ngClass]="{'card-text short-desc': !courseDescriptions[course.CourseId], 'card-text': courseDescriptions[course.CourseId]}" [innerHTML]="course.Description"></p>
        <a class="desc-link" (click)="toggleDesc(course.CourseId)"><i [ngClass]="{'fa fa-chevron-down': !courseDescriptions[course.CourseId], 'fas fa-chevron-up': courseDescriptions[course.CourseId]}"></i>show {{moreorless[course.CourseId]== null?'more' : moreorless[course.CourseId] }}</a>
        }
        @if (column == 'desc') {
        <p class="card-text" [innerHTML]="course.Description"></p>
        }
        }
    </div>
  </div>
}
